export const state = {
  cachedMenu: [
    {
      title: '產品服務',
      children: [
        {
          title: '代理品牌',
          alias: 'brand-list',
          children: [
            {
              title: '品牌系列項目',
              alias: 'brand-category'
            },
            {
              title: '代理品牌項目',
              alias: 'brand-item',
              children: [
                {
                  title: '解決方案',
                  alias: 'brand-solution-list',
                  children: [
                    {
                      title: '解決方案項目',
                      alias: 'brand-solution-item',
                    },
                  ]
                },
                {
                  title: '產品系列',
                  alias: 'brand-product-list',
                  children: [
                    {
                      title: '產品系列項目',
                      alias: 'brand-product-item',
                    },
                  ]
                },
                {
                  title: '課程活動',
                  alias: 'brand-event-list',
                  children: [
                    {
                      title: '課程活動項目',
                      alias: 'brand-event-item',
                      children: [
                        {
                          title: '報名流程',
                          alias: 'event-apply',
                        },
                        {
                          title: '報名完成',
                          alias: 'event-apply-detail',
                        }
                      ]
                    }
                  ]
                },
                {
                  title: '品牌新訊/促銷訊息',
                  alias: 'brand-news-category',
                  children: [
                    {
                      title: '品牌新訊/促銷訊息項目',
                      alias: 'brand-news-item',
                    },
                    // {
                    //   title: '品牌新訊/促銷訊息項目',
                    //   alias: 'news-item',
                    // }
                  ]
                },
                {
                  title: '成功案例',
                  alias: 'brand-case-list',
                  children: [
                    {
                      title: '成功案例項目',
                      alias: 'brand-case-item',
                    }
                  ]
                },
                {
                  title: '檔案下載',
                  alias: 'brand-file',
                },
                {
                  title: '產品影片',
                  alias: 'brand-video-list',
                  children: [
                    {
                      title: '產品影片項目',
                      alias: 'brand-video-item',
                    }
                  ]
                },
              ]
            },
          ]

        },
        {
          title: '產品系列',
          alias: 'product-list',
          children: [
            {
              title: '產品系列項目',
              alias: 'product-item',
            },
          ]
        },
        {
          title: '共同供應契約採購',
          alias: 'bot-list'
        }
      ]
    },
    {
      title: '解決方案',
      alias: 'solution-list',
      children: [
        {
          title: '解決方案項目',
          alias: 'solution-item',
        },
      ]
    },
    {
      title: '課程活動',
      alias: 'event-list',
      /* children: [
        {
          title: '課程活動項目',
          alias: 'event-item',
          children: [
            {
              title: '報名流程',
              alias: 'event-apply',
            },
            {
              title: '報名完成',
              alias: 'event-apply-detail',
            }, 
          ]
        },
      ] */
    },
    {
      title: '關於零壹',
      children: [
        {
          title: '公司簡介',
          alias: 'about-zerone',
        },
        {
          title: '經營團隊',
          alias: 'about-organization',
        },
        {
          title: '大事紀',
          alias: 'about-history',
        },
      ]
    },
    {
      title: '投資人專區',
      children: [
        {
          title: '財務資訊',
          alias: 'investor-finance'
        },
        {
          title: '股東專欄',
          alias: 'investor-shareholders'
        },
        {
          title: '公司治理',
          alias: 'investor-companypolicy'
        },
        {
          title: '利害關係人專區',
          alias: 'investor-int'
        }
      ]
    },
    {
      title: '菁英招募',
      children: [
        {
          title: '加入零壹',
          alias: 'elite-join'
        },
        {
          title: '成長在零壹',
          alias: 'elite-grow'
        },
        {
          title: '生活在零壹',
          alias: 'elite-live'
        },
      ]
    },
    {
      title: '最新消息',
      children: [
        {
          title: '品牌新訊/促銷訊息分類',
          alias: 'news-category',
          children: [
            {
              title: '品牌新訊/促銷訊息項目',
              alias: 'news-item',
            }
          ]
        }
      ]
    },
    {
      title: '影片專區',
      alias: 'video-list',
      children: [
        {
          title: '影片專區項目',
          alias: 'video-item',
        },
      ]
    },
    {
      title: '網站資訊',
      children: [
        {
          title: '網站地圖',
          alias: 'site-map',
        },
        {
          title: '訂閱電子報',
          alias: 'subscription',
        },
        // {
        //   title: '檔案下載',
        //   alias: 'file',
        // },
        {
          title: '隱私權與服務條款',
          alias: 'privacy',
        },
        {
          title: '常見問答',
          alias: 'faq',
        },
        {
          title: '常見問答',
          alias: 'faq-category',
        },
      ]
    },
    {
      title: '聯絡我們',
      children: [
        {
          title: '業務洽詢',
          alias: 'inquiry',
        },
        {
          title: '聯絡銷售人員',
          alias: 'contactSales',
        },
        {
          title: '營業據點',
          alias: 'location',
        },
        {
          title: '維修服務',
          alias: 'repair',
        },
        // 2022/11/01 取消
        // {
        //   title: '申請成為經銷商',
        //   alias: 'tobeDealer',
        // },
        {
          title: '其他詢問',
          alias: 'inquiryOther',
        },
      ]
    },
    {
      title: '聯絡我們',
      alias: 'contact',
    },
    {
      title: '站內搜尋',
      alias: 'search'
    },
    {
      title: '站內搜尋',
      alias: 'search-category'
    },
    {
      title: '站內搜尋',
      alias: 'keyword'
    },
    {
      title: '會員登入',
      alias: 'login'
    },
    {
      title: '會員註冊',
      alias: 'registered'
    },
    {
      title: '會員中心',
      alias: 'member',
      children: [
        {
          title: '會員設定',
          alias: 'member-setting',
        },
        {
          title: '報名清單',
          children: [
            {
              title: '零壹課程',
              alias: 'member-event-list',
              children: [
                {
                  title: '零壹課程項目',
                  alias: 'member-event-item',
                },
                {
                  title: '零壹課程項目直播',
                  alias: 'member-event-item-live',
                },
              ]
            },
            {
              title: '零壹活動',
              alias: 'member-activity-list',
              children: [
                {
                  title: '零壹活動項目',
                  alias: 'member-activity-item',
                },
                {
                  title: '零壹活動項目直播',
                  alias: 'member-activity-item-live',
                },
              ]
            },
          ]
        },
        {
          title: '上課卷',
          alias: 'member-coupon-list',
        },
      ]
    },
    {
      title: '會員資料更新',
      alias: 'member-update',
    },
    {
      title: '問卷調查',
      alias: 'questionnaire',
    },
  ],
};

export const getters = {};

export const mutations = {
  CACHE_MENU(state, menu) {
    state.cachedMenu = menu
  },
};

export const actions = {
  updateMenu({
    commit
  }, menu = {}) {
    commit('CACHE_MENU', menu)
  },
};
